import { forwardRef } from '@chakra-ui/react';

import { Box, type BoxProps } from '@frontend/components';

import { IconButtonGroupProvider } from './IconButtonGroupContext';
import type { IconButtonSize } from './types';

export interface IconButtonGroupProps extends BoxProps {
  size?: IconButtonSize;
}

export const IconButtonGroup = forwardRef<IconButtonGroupProps, 'div'>(
  ({ size, role = 'group', children, ...restProps }, ref) => {
    return (
      <IconButtonGroupProvider value={{ size }}>
        <Box ref={ref} role={role} {...restProps}>
          {children}
        </Box>
      </IconButtonGroupProvider>
    );
  },
);
IconButtonGroup.displayName = 'IconButtonGroup';
